import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/InboundFailureReport';

const InboundFailureReport = ({ t }) => (
  <Container>
    <Row>
      {/* <Col md={12}>
        <h3 className="page-title">REPORTS - ERP VS JARVIS Inventory Report At Item Level</h3>
      </Col> */}
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

InboundFailureReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(InboundFailureReport);
